// This check is necessary for the build process
export const isBrowser = typeof window !== "undefined"
